// import { encodeSSFArgument } from '@/utils/templateEngine';
import googleSheets from '@/config/googleSheets'; // Default to generic number SSF format, with
// auto decimal trimming, and auto abbreviation

export const DEFAULT_CHART_VALUE_TEMPLATE = `{{value | ssf ${googleSheets.formats.number} | trim_dec | abbr auto}}`;